module.exports = __webpack_public_path__ + "static/media/light-b-1.6634b5c8.png";